import { render } from "./PosSubscriptionsManagement.vue?vue&type=template&id=7dcc40fe&scoped=true"
import script from "./PosSubscriptionsManagement.vue?vue&type=script&lang=js"
export * from "./PosSubscriptionsManagement.vue?vue&type=script&lang=js"

import "./PosSubscriptionsManagement.vue?vue&type=style&index=0&id=7dcc40fe&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcc40fe"]])

export default __exports__